<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.dkzj">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Multi-Rolling Mill</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">The features of Multi-Rolling Mills offered by our company as follows：</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>1
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >The entire roll body of the work roll is supported on the archway with the support roll as the medium, and the bending in the width direction of the roll is very small, so that a small diameter work roll can be used.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>2
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >Due to the increased rigidity of the rolling mill and the use of high-hardness rolls, it is possible to produce high-precision products, which can be four times more accurate than the four-roll mill.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>3
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">The new 20-roller mill can roll</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">2.75mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">raw materials to</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.18</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.23</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">and</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">3.0mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">raw materials to</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.2</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.25</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">in one rolling process. At the same time, it can adapt to a variety of alloy steel varieties.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>4
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">Because of reducing the diameter of the work roll, thinner products could be achieved. The thinnest products rolled by the ordinary</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">1250</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">four-roll mill are</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.25mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">. However, it can be rolled to</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.08mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">by the twenty-roll mill.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>5
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">Because the roll diameter is small, the contact area of the deformation zone is reduced</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">,</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">and then the total rolling force is decreased. The rolling force of the twenty-rolling mill</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">(</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">when the rolling conditions are the same</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">)</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">is about</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">25%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">of the four-rolling mill. The reduction of the rolling force reduces the rolling torque</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">,</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">which can save</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">30~40%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">of electrical energy.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>6
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >Because of the actual strengthening of the multi-rolling mills, the rolling passes are reduced and it is possible to cut down the rolling range. Thereby the production efficiency and yield are increased, and the costs are decreased.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>7
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">Because the multi-roll mill uses high tension rolling, the glancing flatness and plate cut of the strip steel are significantly improved.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>8
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">The volume and weight of the rolling mill are reduced, so that the equipment investment cost is relatively decreased.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>9
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >The spare parts (such as rolls, bearings, etc.) commonly used for multi-roller mills are much smaller than four-roller mills, which can greatly reduce costs.</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        dkzj: require("../../../assets/img/common/dkzj.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/dkzj.vue